// extracted by mini-css-extract-plugin
export default {"container":"RegisterPage_container__jZlYI","title":"RegisterPage_title__Iy2k+"};